
import { EthnicityI } from '@interfaces/miscellaneous/miscellaneous';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
const ethnicity: EthnicityI[] = [];

export const ethnicitysSlice = createSlice({
    name: 'ethnicitys',
    initialState: {
        ethnicitys: ethnicity
    },
    reducers: {
        /**
         * @param current state
         * @param action payload with new data to update state
         */
        setEthnicity: (state, action: PayloadAction<EthnicityI>) => {
            state.ethnicitys.push(action.payload);
        },
        removeEthnicity: (state, action: PayloadAction<EthnicityI>) => {
            const index = state.ethnicitys.findIndex((et) => et.code === action.payload.code);
            state.ethnicitys.splice(index, 1);
        },
        cleanEthnicitys: (state) => {
            state.ethnicitys = [];
        }
    },
});

export const { setEthnicity, removeEthnicity, cleanEthnicitys } = ethnicitysSlice.actions;
export default ethnicitysSlice.reducer;
